module.exports = __webpack_public_path__ + "static/media/5.735fa408.JPG";